function initProductCardInfo() {
    if (!document.querySelector('.js-product-card-info-btn')) return;

    document.addEventListener('click', (e) => {
        const target = e.target.closest('.js-product-card-info-btn');

        if (!target) return;

        e.stopImmediatePropagation();

        const content = target.querySelector('.js-product-card-info-content');

        modals.openModal(null, '#product-card-info', modal => {
            const wrapper = modal.querySelector('.js-product-card-info-wrapper');

            wrapper.innerHTML = content.innerHTML;
        })
    })
}
